import { render, staticRenderFns } from "./NavlinkDialog-2023-08-07.vue?vue&type=template&id=4c1a7e65&"
import script from "./NavlinkDialog-2023-08-07.vue?vue&type=script&lang=js&"
export * from "./NavlinkDialog-2023-08-07.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports